import React, { useState } from 'react';
import { UseState } from 'services/TypeUtils';
import './style.scss';

type Props = {
  titleOn: string;
  titleOff: string;
  handler: UseState<boolean>;
};

function InlineToggle({ titleOn, titleOff, handler }: Props) {
  const [on, setOn] = handler;
  return (
    <div className="inline-toggle" data-is-on={on} onClick={() => setOn((prev) => !prev)}>
      <span>{on ? titleOn : titleOff}</span>
    </div>
  );
}

export default InlineToggle;

export function InlineSwitch({ titles, handler }: { titles: string[]; handler: UseState<number> }) {
  const [idx, setIdx] = handler;

  return (
    <div className="inline-switch">
      {titles.map((it, i) => {
        return (
          <div className="wrapper">
            <span onClick={() => setIdx(i)} data-is-on={i === idx}>
              {it}
            </span>
          </div>
        );
      })}
    </div>
  );
}
